<template>
    <div data-app class="p-1">
        <notifications v-if="isPublic"></notifications>
        <restocking-management-page
            v-if="type == typeUpdateAmplitudeParameter"
            :items="items"
            :itemsBackups="itemsBackups"
            @notify="notifyMessage"
            :_create="create"
            @setItems="setItems"
            @setItemsBackups="setItemsBackups"
        />
        <extra-product-page
            v-else-if="type == typeRequestExtraProduct"
            :items="items"
            :itemsBackups="itemsBackups"
            :_create="create"
            @notify="notifyMessage"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import Notifications from '@/components/NotificationPlugin'
import { mapActions, mapState } from 'vuex'
import ExtraProduct from './pages/ExtraProduct.vue'
import RestockingManagement from './pages/RestockingManagement.vue'
import {
    status as Status,
    solicitationTypes as Types
} from '@/services/constants/index.js'

const permittedSolicitationTypes = [
    Types.TYPE_UPDATE_AMPLITUDE_PARAMETER_PK,
    Types.TYPE_REQUEST_EXTRA_PRODUCT_PK
]

export default {
    async created() {
        this.isPublic = this.$route.meta.public ?? false
        try {
            if (this.isPublic) {
                Vue.use(Notifications)

                const token = this.$route.query.token

                if (!token) {
                    this.$router.push('/login')
                    return
                }

                await this.generateToken({ token })
                this.type = this.me.solicitation_type
                await this.readBranchById(this.me.branch)
            } else {
                if (
                    !this.type ||
                    isNaN(this.type) ||
                    !permittedSolicitationTypes.includes(this.type)
                ) {
                    this.$router.push('/solicitations')
                    return
                }
            }
            await this.readMe({ offline: this.isPublic ? false : true })
        } catch {
            this.$router.push('/login')
            return
        }
    },
    props: {
        solicitationType: {
            required: false
        }
    },
    data() {
        return {
            typeUpdateAmplitudeParameter:
                Types.TYPE_UPDATE_AMPLITUDE_PARAMETER_PK,
            typeRequestExtraProduct: Types.TYPE_REQUEST_EXTRA_PRODUCT_PK,
            items: [],
            itemsBackups: [],
            type: this.solicitationType,
            isPublic: false
        }
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me
        })
    },
    methods: {
        ...mapActions('branches', {
            readBranchById: 'readById'
        }),
        ...mapActions('auth', {
            readMe: 'me',
            generateToken: 'generateToken'
        }),
        ...mapActions('solicitations', {
            createSolicitation: 'create'
        }),

        notifyMessage({ message, type }) {
            this.$notify({
                message,
                icon: 'add_alert',
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type
            })
        },
        setItems(items) {
            this.items = items
        },
        setItemsBackups(itemsBackups) {
            this.itemsBackups = itemsBackups
        },
        resetItems() {
            this.items = []
            this.itemsBackups = []
        },
        async create(solicitation, reset = true) {
            const source = this.isPublic ? 'A' : 'W'
            const body = source == 'W' ? 'request_body_web' : 'request_body'
            const response = await this.createSolicitation({
                ...solicitation,
                status: Status.APPROVED,
                request_user: this.me.id,
                body,
                source
            })
            const wasCreated = response.status === 201

            if (!wasCreated || reset) {
                this.notifyMessage({
                    message: response.message,
                    type: wasCreated ? 'success' : 'danger'
                })
                if (wasCreated) {
                    this.resetItems()

                    if (!this.isPublic) {
                        this.$router.push('/solicitations')
                    }
                }
            }
        }
    },
    components: {
        'extra-product-page': ExtraProduct,
        'restocking-management-page': RestockingManagement
    }
}
</script>

<style scoped>
.add-btn {
    margin: 15px 0px;
}
.card-content {
    padding: 20px;
}
.card-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
}
.card-row::after {
    content: '';
    flex: auto;
}
.card-column {
    max-width: 400px;
    height: 730px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 400px;
    margin-bottom: 100px;
}
.card-text-field {
    margin-top: -25px;
    margin-left: 10px;
    margin-bottom: 10px;
    width: 100px;
}
.card-select-field {
    margin-top: -25px;
    margin-left: 10px;
    margin-bottom: 10px;
    max-width: 220px;
}
.card-textarea-field {
    margin-top: -25px;
    margin-left: 10px;
    margin-right: 40px;
    max-width: 220px;
}
.v-card,
li {
    margin-bottom: 30px;
}
ul {
    list-style: none;
}
#save-btn {
    position: fixed;
    bottom: 0;
    padding: 5px 15px;
}
.modal-header > h1 {
    font-size: 18px;
}
.modal-header > h1,
.modal-body > p > span {
    font-weight: bold;
}
.confirm-btns {
    display: inline-block;
    width: 100%;
}
.confirm-btns > .btn {
    width: 49%;
}
.left {
    float: left;
}
.right {
    float: right;
}
@media (min-width: 601px) {
    .add-btn {
        float: right;
    }
    #save-btn {
        right: 2%;
    }
}
@media (max-width: 600px) {
    .v-card {
        text-align: center;
    }
    #save-btn {
        width: 100%;
        left: 0;
    }
    .add-btn > .btn,
    #save-btn > .btn {
        width: 100%;
    }
}
</style>
